'use client';

import React from 'react';

import { Svg } from '@ui/svg';
import { cn } from '@/utilities/cn';

export const ArrowForLink: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <div
      className={cn(
        'group-hover:ring-blue/70 md:group-hover-[113px] flex h-10 w-10 items-center justify-end overflow-hidden rounded-full bg-[#E9EDF4] px-[14px] ring-2 ring-transparent transition-all duration-500 group-hover:w-[136px] md:h-8 md:w-8 md:px-[11px]',
        className,
      )}
    >
      <div className="h7">Смотреть</div>
      <div className="div flex-none pl-[14px]">
        <Svg className="md:w-[10px]" id="arrow-square" width={12} height={12} />
      </div>
    </div>
  );
};
